import ScrollToTop from "../hooks/ScrollToTop";
import UserLayout from "./UserLayout";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home/Home";
import Contact from "../pages/Contact/Contact";
import About from "../pages/About/About";
import Error from "../pages/404/Error";
import Collaboration from "../pages/Collaboration/Collaboration";
import CraftPreservation from "../pages/CraftPreservation/CraftPreservation";
import Blog from "../pages/Blog/Blog";
import BlogDetail from "../pages/BlogDetail/BlogDetail";
import Haldi from "../pages/Haldi/Haldi";
import Mehandi from "../pages/Mehandi/Mehandi";
import Sangeet from "../pages/Sangeet/Sangeet";
import Contemporary from "../pages/Contemporary/Contemporary";
import Wedding from "../pages/Wedding/Wedding";
import Process from "../pages/Process/Process";
import Gifting from "../pages/Gifting/Gifting";
import Thankyou from "../pages/thankyou/Thankyou";
import Festive from "../pages/Festive/Festive";
import DynamicPages from "../pages/DynamicPages/DynamicMainPage";
import ContactUs from "../pages/Contact/ContactUs";
import StartMyJourney from "../pages/StartMyJourney";

export default function NavRouter({ initialData }) {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<UserLayout />}>
          <Route index element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="about-us" element={<About />} />
          <Route path="collaboration" element={<Collaboration />} />
          <Route path="craft-preservation" element={<CraftPreservation />} />
          <Route path="blog" element={<Blog initialData={initialData} />} />
          <Route path="blog/:blog_slug" element={<BlogDetail initialData={initialData} />} />
          <Route path="haldi-dresses" element={<Haldi />} />
          <Route path="mehandi-dresses" element={<Mehandi />} />
          <Route path="sangeet-suit" element={<Sangeet />} />
          <Route path="contemporary" element={<Contemporary />} />
          <Route path="wedding-dress-designers" element={<Wedding />} />
          <Route path="our-process" element={<Process />} />
          <Route path="gifting" element={<Gifting />} />
          <Route path="festive-wear" element={<Festive />} />
          <Route path="/:dynamicslug" element={<DynamicPages initialData={initialData} />} />
        </Route>

        {/* Routes without footer*/}
        <Route element={<UserLayout footerHide="footer-hider" />}>
          <Route path="404" element={<Error />} />
          <Route path="*" element={<Navigate to={"/404"} />} />
          <Route path="thankyou" element={<Thankyou />} />
        </Route>

        {/* Routes with a logo-only header and no footer */}
        <Route element={<UserLayout simpleHeader footerHide="footer-hider" />}>
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="contact-us/thankyou" element={<Thankyou hideSocial disableAutoRedirect />} />
          <Route path="/start-my-journey" element={<StartMyJourney />} />
        </Route>
      </Routes>
    </>
  );
}
